import React from 'react';
import Styled from './CheckboxStyles';

export const Checkbox = (props) => {
    const { id, name, value, label, style, onChange, disabled = false, checked } = props;

    return (
        <div
            style={{
                ...style
            }}
            id={id}
        >
            <Styled.Input
                id={`${name}-${value}`}
                type="checkbox"
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
                checked={checked}
            />
            <Styled.Label htmlFor={`${name}-${value}`}>
                <Styled.Checkmark
                    style={{
                        height: 16,
                        width: 16,
                        display: checked ? 'block' : 'none'
                    }}
                />
                {label}
            </Styled.Label>
        </div>
    );
};

export default React.memo(Checkbox);